module.exports = __webpack_public_path__ + "9779d9a1/img/note-edit-icon.acae1669.svg";